export const version = '0.815.1'
export const chameleonWebVersion = '10.5.2'
export const chameleonCoreVersion = '7.14.0'
